"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringIsInteger = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const stringIsInteger = (integer, positiveNumbersOnly = true) => {
    const stringInteger = String(integer);
    if (!stringInteger.match(/^[-]?\d+$/)) {
        return false;
    }
    const bNparsed = new bignumber_js_1.default(stringInteger);
    const limit = positiveNumbersOnly ? 0 : -1;
    return (bNparsed.toString(10) === stringInteger && bNparsed.comparedTo(0) >= limit);
};
exports.stringIsInteger = stringIsInteger;
//# sourceMappingURL=stringIsInteger.js.map